import { defineComponent as _defineComponent } from 'vue';
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, withModifiers as _withModifiers, openBlock as _openBlock, createBlock as _createBlock } from "vue";
const _hoisted_1 = /*#__PURE__*/_createTextVNode(" generate match ");
const _hoisted_2 = /*#__PURE__*/_createTextVNode(" home ");
const _hoisted_3 = {
  class: "flex items-center w-full"
};
const _hoisted_4 = {
  class: "grow"
};
const _hoisted_5 = {
  class: "px-2"
};
const _hoisted_6 = /*#__PURE__*/_createTextVNode("generate");
import DefaultInGameLayout from "@/modules/base/layouts/DefaultInGameLayout.vue";
import { Season } from "@/modules/season/entity";
import { app } from "@/di";
import FriendlyGenerator from "@/modules/team/services/FriendlyGenerator";
export default /*#__PURE__*/_defineComponent({
  __name: 'GenerateMatchPage',
  setup(__props) {
    const form = ref({
      home: true,
      skillRange: [10, 100]
    });
    const rules = ref({
      home: {
        type: 'boolean',
        required: true
      },
      skillRange: {
        type: 'array',
        required: true
      }
    });
    const router = useRouter();
    const onSubmit = async () => {
      const season = await Season.current();
      await app.get(FriendlyGenerator).generate(form.value);
      await router.push({
        name: 'index'
      });
    };
    return (_ctx, _cache) => {
      const _component_NCheckbox = _resolveComponent("NCheckbox");
      const _component_NFormItem = _resolveComponent("NFormItem");
      const _component_NSlider = _resolveComponent("NSlider");
      const _component_NButton = _resolveComponent("NButton");
      const _component_NForm = _resolveComponent("NForm");
      return _openBlock(), _createBlock(_component_NForm, {
        ref: "formComponent",
        model: form.value,
        rules: rules.value,
        onSubmit: _withModifiers(onSubmit, ["prevent"])
      }, {
        default: _withCtx(() => [_createVNode(DefaultInGameLayout, {
          back: ""
        }, {
          title: _withCtx(() => [_hoisted_1]),
          footerButtons: _withCtx(() => [_createVNode(_component_NButton, {
            secondary: "",
            "attr-type": "submit",
            type: "success",
            size: "large"
          }, {
            default: _withCtx(() => [_hoisted_6]),
            _: 1
          })]),
          default: _withCtx(() => [_createVNode(_component_NFormItem, {
            label: "player at home",
            path: "form.home"
          }, {
            default: _withCtx(() => [_createVNode(_component_NCheckbox, {
              checked: form.value.home,
              "onUpdate:checked": _cache[0] || (_cache[0] = $event => form.value.home = $event)
            }, {
              default: _withCtx(() => [_hoisted_2]),
              _: 1
            }, 8, ["checked"])]),
            _: 1
          }), _createVNode(_component_NFormItem, {
            label: "skill range",
            path: "form.skillRange"
          }, {
            default: _withCtx(() => [_createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [_createVNode(_component_NSlider, {
              value: form.value.skillRange,
              "onUpdate:value": _cache[1] || (_cache[1] = $event => form.value.skillRange = $event),
              range: "",
              step: 10
            }, null, 8, ["value"])]), _createElementVNode("div", _hoisted_5, _toDisplayString(Math.min(...form.value.skillRange)) + " - " + _toDisplayString(Math.max(...form.value.skillRange)), 1)])]),
            _: 1
          })]),
          _: 1
        })]),
        _: 1
      }, 8, ["model", "rules", "onSubmit"]);
    };
  }
});